/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorCustomLinks as ResolvedLabradorCustomLinks } from 'base/components/labrador/CustomLinks';

export const LabradorCustomLinks: typeof ResolvedLabradorCustomLinks = withLabradorInstanceof((props) => {
    return <ResolvedLabradorCustomLinks {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorCustomLinksProps = PropsFromComponent<typeof LabradorCustomLinks>;
